import { createSlice } from "@reduxjs/toolkit";
import { updateWabaProfileData, getWabaProfileData, updateWabaProfilePic } from "./waba-prifile-actions";
const default_waba_profile_state = {
    loading:false,
    wabaProfileData:null,
    profilePic:null
}

const waba_profile_slice = createSlice({
    name:"waba-profile",
    initialState:default_waba_profile_state,
    reducers: {},
    extraReducers:(builder) => {
        builder.addCase(updateWabaProfileData.pending,(state) => {
            state.loading = true
        });
        builder.addCase(updateWabaProfileData.fulfilled,(state, {payload}) => {
            console.log("update payload", payload);
            state.loading = false
        });
        builder.addCase(updateWabaProfileData.rejected,(state) => {
            state.loading = false
        });

        builder.addCase(updateWabaProfilePic.pending,(state) => {
            state.loading = true;

        });
        builder.addCase(updateWabaProfilePic.fulfilled,(state, { payload }) => {
            state.loading = false
            console.log('update pic', payload);
            state.profilePic = payload.message;
        });
        builder.addCase(updateWabaProfilePic.rejected,(state) => {
            state.loading = false
        })

        builder.addCase(getWabaProfileData.pending,(state) => {
            state.loading = true
        });
        builder.addCase(getWabaProfileData.fulfilled,(state, {payload}) => {
            console.log('get profile', payload);
            state.loading = false;
            state.wabaProfileData = {...payload?.business};
            state.profilePic = payload?.business.profilePictureUrl;
            
        });
        builder.addCase(getWabaProfileData.rejected,(state) => {
            state.loading = false
        })
    }
})


export default waba_profile_slice.reducer;